import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const VinNumberHeading = styled.div`
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-top: 10px;
`;

export const VinNumberText = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #666666;
    margin-top: 5px;
`;

export const InputWrapper = styled.div`
    display: flex;
    margin-top: 10px;
    flex-direction: column;
`;

export const EnterMoreDetails = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
`;

export const ButtonWrapper = styled.div`
    margin-top: 25px;
    margin-bottom: 10px;
`;

export const ManualFlowMessage = styled.div`
    width: 100%;
    border-radius: 10px;
    margin-top: 10px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background: rgb(247, 199, 187);
`;

export const InputAndScanWrapper = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-end;
    width: 100%;
`;

export const InputContainer = styled.div`
    flex: 1;
`;

export const ScanButton = styled.button`
    padding: 12px 16px;
    background-color: #40a7a3;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s ease;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
        background-color: #358a87;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const InputCard = styled.div`
    margin-top: 10px;
    padding: 15px;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid #e3e4f2;
    box-shadow: 0 2px 10px rgba(4, 2, 34, 0.08);
`;
